import styled from "@emotion/styled";
import BaseButton from "src/atoms/Button/BaseButton";
import { IColor } from "@otrium/core";
import NextLink from "next/link";

const Button = styled(BaseButton)<{
  color?: string | IColor;
}>`
  border: none;
  display: flex;
  background-color: transparent;
  color: ${({ theme, color }) => color || theme.colors.tone.black};
  cursor: pointer;

  svg {
    margin-right: ${({ theme }) => theme.space[2]}px;
    fill: ${({ theme }) => theme.colors.tone.black};
  }

  p {
    color: ${({ theme, color }) => color || theme.colors.tone.black};
  }

  :disabled {
    color: ${({ theme }) => theme.colors.tone.anthraciteLight};
    cursor: default;
    text-decoration: none;
    svg {
      fill: ${({ theme }) => theme.colors.tone.anthraciteLight};
    }
  }

  &.with-underline {
    text-decoration: underline;
    text-decoration-thickness: 2px;
    text-underline-position: under;

    &:not(.with-icon):hover,
    &:not(.with-icon):active {
      text-decoration: underline;
      text-decoration-thickness: 2px;
      text-underline-position: under;
    }
  }

  &.full-width {
    width: 100%;
  }
`;

const Link = Button.withComponent(NextLink);

export { Button, Link };
